import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { configurationSubject } from './app/environment-resolver';

const configurationLoadedEvent = document.createEvent('Event');
configurationLoadedEvent.initEvent('config-set', true, true);
fetch('./assets/config.json')
.then(result => result.json())
.then(data => {
  window['environment'] = data;
  document.dispatchEvent(configurationLoadedEvent);
}, error => window.location.reload());

if (!window['environment']) {
  document.addEventListener('config-set', function(e) {
    if (window['environment'].production) {
      enableProdMode();
    }
    configurationSubject.next(window['environment']);
    window['environment'] = undefined;
    platformBrowserDynamic().bootstrapModule(AppModule)
    .catch();
  });
}
